import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import Button from './UIKit/Button';

/**
 * Компонент диалога подтверждения действия
 * 
 * @param {Object} props - Свойства компонента
 * @param {boolean} props.open - Флаг открытия диалога
 * @param {Function} props.onConfirm - Функция, вызываемая при подтверждении
 * @param {Function} props.onCancel - Функция, вызываемая при отмене
 * @param {string} props.title - Заголовок диалога
 * @param {string} props.content - Содержимое диалога
 * @param {string} props.confirmText - Текст кнопки подтверждения
 * @param {string} props.cancelText - Текст кнопки отмены
 * @returns {JSX.Element}
 */
const ConfirmDialog = ({
  open,
  onConfirm,
  onCancel,
  title = 'Подтверждение',
  content = 'Вы уверены, что хотите выполнить это действие?',
  confirmText = 'Подтвердить',
  cancelText = 'Отмена',
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
      PaperProps={{
        elevation: 0,
        sx: {
          borderRadius: '16px',
          p: 1,
        },
      }}
    >
      <DialogTitle id="confirm-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-dialog-description">
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onCancel} color="primary">
          {cancelText}
        </Button>
        <Button variant="contained" onClick={onConfirm} color="error" autoFocus>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog; 